import styled from 'styled-components';

const StyledMoneyfy = styled.section`
  font-family: ${(props) => props.theme.Muli};
  overflow-x: hidden;
  .default_class, .scroll_class{
    display: none;
  }
  .nav-bg-white{
    background: ${(props) => props.theme.whiteColor};
    border: 1px solid ${(props) => props.theme.borderGray};
    .text-red{
      color: ${(props) => props.theme.primaryColor};
    }
  }
  .moneyfy-header{
    background: ${(props) => props.theme.primaryColor};
    border-radius: 8px;
    padding: 8px 0px;
    .moneyfy-logo{
      padding: 15px;
      background: ${(props) => props.theme.whiteColor};
      border-radius: 0px 50px 50px 0px;
    }
    .text-white{
      color: ${(props) => props.theme.whiteColor};
    }
  }
  .bdr-hr{
    width: 5%;
    border: 3px solid ${(props) => props.theme.primaryColor};
    border-radius: 5px;
  }
  .moneyfy-features-imgs{
    width: 40px;
  }
  .hightlighter{
    background: ${(props) => props.theme.whiteColor};
    border-radius: 8px;
    box-shadow: 0px 2px 4px ${(props) => props.theme.borderGray};
    padding: 10px;
    .text-highlight{
      font-style: italic;
      font-weight: bolder;
      color: ${(props) => props.theme.primaryColor};
    }
  }
  .btn-green{
    border-radius: 25px;
    background: ${(props) => props.theme.lightGreen};
    color: ${(props) => props.theme.whiteColor};
  }
`;

export default StyledMoneyfy;



// WEBPACK FOOTER //
// client/containers/Campaigns/Moneyfy/StyledMoneyfy.js